// extracted by mini-css-extract-plugin
export default {"dialog-header":"Dialog_dialog-header__98b07","close-icon":"Dialog_close-icon__Eu-f0"};